export const GPT_IMAGE_2_SIZES = [
    '1024x1024',
    '1024x1536',
    '1536x1024',
    '2048x2048',
    '2048x1152',
    '1152x2048',
    '2560x1440',
    '1440x2560',
    '3840x2160',
    '2160x3840',
];
/** Highest tier last: a stored tier a model does not offer is clamped to the last entry. */
export const GPT_IMAGE_QUALITIES = ['auto', 'low', 'medium', 'high'];
export const GPT_IMAGE_25_QUALITIES = [...GPT_IMAGE_QUALITIES, 'xhigh', 'max'];
